
<template>
    <div class="screenSearchPop">
        <div class="searchSetBox">

            <div class="searchSet">
                <!-- 拥有人 -->
                <div class="title">{{$t('mx_mobile.Client.1627009054565')}}</div>
                <div style="vertical-align: middle;margin-bottom: 0.85rem;">
                    <!-- 全部 -->
                    <van-button type="primary" size="small" style="border: none; padding: 0 1rem; font-size: 0.6rem; background: #D0021B; vertical-align:middle; margin-right: 0.95rem" @click="openOwnerSelector()"> {{ selectedOwner.name || $t('mx_mobile.Client.1627009173954') }} </van-button>
                    <i @click="openOwnerSelector()" class="iconfont icon-search" style="vertical-align: middle; display: inline-block"></i>
                </div>
            </div>

            <template v-for="(item, index) in searchData">
                <div class="searchSet" :key="index" v-if="item.fieldGroup == 0 && item.controlTypeId==2">
                    <div class="title">{{item.cnFieldCaption}}</div>
                    <searchLabelsV ref="searchLabelsV" :list="item" moduleCode="BF001" :sysBoxValue="sysBoxValue"></searchLabelsV>
                </div>
            </template>
            <!-- 标签(后台服务暂不支持，先隐藏) -->
            <div class="searchSet">
                <div class="title">{{tags.cnFieldCaption}}</div>
                <tag moduleCode="BF001" ref="tag" :list="tags" :listLabels="listLabels"></tag>
            </div>
        </div>
        <div class="footer">
            <div class="leftBut" @click="clear()">
                <!-- 重置 -->
                {{$t('mx_mobile.Client.1585286717723')}}
            </div>
            <div class="rightBut" @click="submit()">
                <!-- 完成 -->
                {{$t('mx_mobile.Client.1585286721404')}}
            </div>
        </div>
    </div>

</template>
<script>
import searchLabelsV from '../Vue/searchLabelsV.vue'
import PersonnelSelection from '@/page/Mail/MailPublic/PersonnelSelection/index'
import tag from '../Vue/tag.vue'
import MXEventBus from '@/libs/eventBus'

export default {
    name: 'ContentItem',
    props: {
        sysBoxValue: {
            type: Array,
            default: function () {
                return []
            }
        },
        listLabels: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            searchData: [],
            tags: {
                cnFieldCaption: this.$t('mx_mobile.Client.1585277425271'), // 标签
                cnFieldHint: '',
                columnWidth: 120,
                controlTypeId: 'tags',
                dictCode: 11673,
                editState: 1,
                fieldCategory: 3,
                fieldGroup: 0,
                fieldId: 68,
                fieldLength: 10,
                fieldName: 'tags',
                inDefaultValue: '',
                isNotNull: 0,
                moduleCode: 'BF001',
                parFilterField: '',
                stDefaultValue: '',
                strucId: 1,
                uniqueCheck: 0
            },
            selectedOwner: {
                ctId: '',
                name: this.$t('mx_mobile.Client.1627009173954') // 全部
            }
        }
    },
    created() {
        MXEventBus.$on('selectedOwner', (selectedOwner) => {
            this.selectedOwner.ctId = selectedOwner.ctId
            this.selectedOwner.name = selectedOwner.realName
        })
    },
    mounted() {
        this.getSearchData()
    },
    watch: {
    },
    computed: {
    },
    methods: {
        clear() {
            this.$refs.searchLabelsV.forEach(element => {
                element.clear()
            })
            this.$refs.tag.clear()
            this.selectedOwner = {
                ctId: '',
                name: this.$t('mx_mobile.Client.1627009173954') // 全部
            }
        },
        submit() {
            let obj = {}

            this.$refs.searchLabelsV.forEach(element => {
                Object.assign(obj, element.submit())
            })
            Object.assign(obj, this.$refs.tag.submit())
            this.selectedOwner.ctId && (obj['ownerCtId'] = this.selectedOwner.ctId)
            this.$emit('getListData', obj)
            this.$emit('screenSearchClick', false)
        },
        getSearchData() {
            let _this = this
            let data = {
                moduleCode: 'BF001',
                type: 'searchSet'
            }
            _this.axios.get(_this.Global.config.apiBaseURL + _this.Global.api.v2.fieldShow_get, { params: data }).then((res) => {
                if (res.data.code.toString() === _this.Global.config.RES_OK) {
                    let searchData = res.data.data
                    _this.searchData = _this.swidchEditSet(searchData)
                } else {
                    _this.$toast.fail(res.data.msg)
                }
            }, function (res) {
                _this.$toast.fail(_this.Global.config.errorTitle)
            })
        },
        swidchEditSet(list) { // 编辑字段数据转化
            // let _this = this
            let newLList = []
            let groupFirst = []
            list.forEach((element) => {
                element.controlData = ''
                element.check = ''
                element.inDefaultValue = ''
                if (element.fieldGroup !== 0) { // 判断是否是一个组
                    let isHave = false
                    let thisGroup = ''
                    groupFirst.forEach((item) => { // 判断这个组是否出现过，出现则在groupFirst里做个标记
                        if (item == element.fieldGroup) {
                            isHave = true
                            thisGroup = item // 记住这个组id
                        }
                    })
                    if (!isHave) { // 如果没有出现过新建一个对象放入newList里面
                        let newObj = {
                            fieldId: element.fieldId,
                            fieldGroup: element.fieldGroup,
                            // cnFieldCaption: _this.returnGroupName(element.fieldGroup),
                            cnFieldCaption: '',
                            group: []
                        }
                        newObj.group.push(element)
                        newLList.push(newObj)
                        groupFirst.push(element.fieldGroup)
                    } else { // 如果出现过就找之前创建的对象将自己放入到group数组中
                        newLList.forEach(function (them) {
                            if (them.fieldGroup == thisGroup) {
                                them.group.push(element)
                            }
                        })
                    }
                } else {
                    newLList.push(element)
                }
            })
            return newLList
        },
        openOwnerSelector() {
            this.$router.push({ name: 'OwnerSelector' })
        }

    },
    components: {
        'searchLabelsV': searchLabelsV,
        'personnel-selection': PersonnelSelection,
        'tag': tag
    }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "./zh-cn.less";
@import "./en.less";
</style>
